import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useBlocker } from 'react-router-dom';
import {
  AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, useDisclosure,
} from '@chakra-ui/react';
import useFormDraft from '../../helpers/useFormDraft';
import { getForm, setForm } from '../../Components/FormSetup/formSlice';

const FormLayout = () => {
  const { isFetching, data: form } = useFormDraft();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const { dirty } = useSelector(getForm);
  const cancelRef = useRef();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname,
  );
  useEffect(() => {
    if (!isFetching) {
      dispatch(setForm(form));
    }
  }, [isFetching, form?.id]);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      onOpen();
    }
  }, [blocker.state]);

  const handleCancel = () => {
    blocker.reset();
    onClose();
  };

  const handleContinue = () => {
    blocker.proceed();
    onClose();
  };

  return (
    <>
      <Outlet />
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Your changes are not save
            </AlertDialogHeader>

            <AlertDialogBody>
              If you continue your changes will be lost
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={handleCancel} size="sm">
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleContinue} ml={3} size="sm">
                Continue
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default FormLayout;
